module.exports = __webpack_public_path__ + "static/media/peter.1df36121.png";